// Khsale.jsx ✅ updated with i18n (translations) + logic same
import React, { useEffect, useRef, useState, useContext } from 'react'
import './Khsale.css'
import back from "../../imgs/backexam.png";
import date from "../../imgs/bdate.png";
import khadya from "../../imgs/khadya.png";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { UilEditAlt, UilTrash, UilSetting } from '@iconscout/react-unicons'
import { useLocation, useNavigate } from "react-router-dom";
import Globalcontext from '../../Context/Globalcontext';
import cash from "../../imgs/cash.png";

import { useTranslation } from "react-i18next";

const Khsale = (props) => {
    const inputRefs = useRef([]);
    const [newedit, setNewedit] = useState("new");
    const [input, setInput] = useState({ date: new Date().toISOString().substr(0, 10), date1: "", date2: new Date().toISOString().substr(0, 10), kno: "", name: "", khname: "", khcompany: "", quin: "", rate: "", amt: "", tquin: "", tamt: "", remark: "", etype: "उधारी" });
    const [dates, setDates] = useState({ date1: "", date2: new Date().toISOString().substr(0, 10) });
    const [DataSource, setDataSource] = useState([]);
    const [tableFilter, setTableFilter] = useState([]);
    const [khnames, setKhnames] = useState([]);
    const [company, setCompany] = useState([]);
    const [value, setValue] = useState('');
    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const { sanksource, setSanksource, setHeadname } = useContext(Globalcontext);
    const { submenu, setsubmenu, newcustsource, setNewcustsource, custlist, setCustlist } = useContext(Globalcontext);
    const [stock, setStock] = useState();
    const [sredit, setSredit] = useState('');
    const [srdelete, setSrdelete] = useState('');
    const [stockcompany, setStockcompany] = useState();
    const [wait, setWait] = useState(false);
    const refprint2 = useRef(null);
    const refprint2close = useRef(null);
    const refdelete = useRef(null);
    const refdeleteclose = useRef(null);
    const today = new Date().toISOString().split('T')[0];

    const [t] = useTranslation();

    function handleEnterKey(event, currentIndex) {
        if (event.key === 'Enter' || event.key === "Tab") {
            event.preventDefault();
            let nextIndex = null;
            nextIndex = currentIndex + 1;
            if (inputRefs.current[nextIndex]) {
                inputRefs.current[nextIndex].focus();
            }
        }

        // keep as-is (existing Marathi values)
        if (event.key === 'Backspace' && (
            (event.target.tagName === 'INPUT' && event.target.value === '') ||
            (event.target.tagName === 'SELECT' && (
                (event.target.name === 'type' && event.target.value === 'प्रकार निवडा') ||
                (event.target.name === 'time' && event.target.value === 'वेळ निवडा')
            ))
        )) {
            event.preventDefault();

            let prevIndex = currentIndex - 1;
            while (prevIndex >= 0) {
                const prevElement = inputRefs.current[prevIndex];
                if (prevElement) {
                    if (
                        (prevElement.tagName === 'INPUT' || prevElement.tagName === 'SELECT') &&
                        prevElement !== event.target
                    ) {
                        prevElement.focus();
                        break;
                    } else {
                        prevIndex--;
                    }
                } else {
                    prevIndex--;
                }
            }
        }
    }

    const handleprintclose = () => {
        refprint2close.current.click();
    }

    const handlePrint = () => {
        refprint2.current.click();
    }

    const handleDeleteclose = () => {
        setSrdelete("");
        refdeleteclose.current.click();
    }

    const handleDelete = (sr) => {
        setSrdelete(sr);
        refdelete.current.click();
    }

    const getstock = async () => {
        if (input.khname) {
            khnames.map((user, index) =>
                user.khname === input.khname ?
                    setStock(user.current_stock)
                    : ""
            )
        }
        else {
            setStock("");
            setStockcompany("");
        }
        getkhcompany();
    }

    useEffect(() => {
        setStock("");
        setStockcompany("");
        setCompany([]);
        getkhcompany();
    }, [input.khname])

    const getstockcompany = async () => {
        if (input.khcompany) {
            company.map((user, index) =>
                user.khcompany === input.khcompany && user.khcompany !== "-" ?
                    setStockcompany(user.current_stock)
                    : ""
            )
        }
        getkhcompany();
    }

    async function getkhcompany() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        setTimeout(() => {
            props.setProgress(70);
        }, 200);
        axios.post('https://excellentdairy.com/dairy/php/cust/getkhcompany.php', { khname: input.khname, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                setCompany(response.data);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        }).replace(/ /g, '-');
    };

    useEffect(() => {
        if (input.kno === "") {
            setInput(prevInput => ({
                ...prevInput,
                kno: "",
                name: "",
                khname: "",
                quin: "",
                rate: "",
                amt: "",
            }))
        }
        else {
            let custlisttemp = JSON.parse(localStorage.getItem("custlist"));
            for (let i = 0; i < custlisttemp.length; i++) {
                setInput(prevInput => ({
                    ...prevInput,
                    name: ''
                }));
                const user = custlisttemp[i];
                if (user.kno === input.kno) {
                    setInput(prevInput => ({
                        ...prevInput,
                        name: user.cname
                    }));
                    break;
                }
            }
        }
    }, [input.kno])

    useEffect(() => {
        if (input.rate && input.rate !== "" && input.quin && input.quin !== "") {
            let amt = parseFloat(parseFloat(input.rate) * parseFloat(input.quin)).toFixed(2);
            setInput(prevInput => ({
                ...prevInput,
                amt: amt,
            }))
        }
    }, [input.rate, input.quin])

    const savekhadyasale = () => {
        setWait(true);
        var mainuser2 = jsEncode.encode("mamapr", 125);

        if (input.date === "" || input.kno === "" || input.name === "" || input.khname === t("khsale.placeholders.select_feed") || input.khname === "" || input.quin === "" || input.rate === "" || input.amt === "" || input.remark === "") {
            notifyerror(t("khsale.toast.incomplete"));
            setWait(false);
            return;
        }

        const line = input.khname;
        const [khnametemp, purdatetemp] = line.split(":").map(part => part.trim());

        let rawData = {
            date: input.date,
            kno: input.kno,
            etype: input.etype, // keep excellentdairy string
            khname: khnametemp,
            purdate: purdatetemp != null && purdatetemp !== "" ? purdatetemp : '-',
            khcompany: input.khcompany,
            quin: input.quin,
            rate: input.rate,
            amt: input.amt,
            remark: input.remark,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            flag: newedit,
            sredit: sredit,
            date1: dates.date1,
            date2: dates.date2,
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://excellentdairy.com/dairy/php/cust/savekhsale4.php', formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {

            if (newedit === "new") {
                if (response.data.trim() === "Saved.") {
                    notify(t("khsale.toast.saved"));
                    setWait(false);
                }
            }
            else {
                if (response.data.trim() === "updated.") {
                    notify(t("khsale.toast.updated"));
                    setWait(false);
                }
            }

            setInput(prevInput => ({
                ...prevInput,
                kno: "",
                name: "",
                khname: "",
                khcompany: "",
                quin: "",
                rate: "",
                amt: "",
                remark: "",
            }))
            setSredit("");
            setNewedit("new");
            getkhsale(dates.date1, dates.date2);
            if (inputRefs.current[1]) inputRefs.current[1].focus();

        }).catch(err => {
            console.log(err);
            setWait(false);
        });
    }

    const handleedit = (sr, date, kno, name, khname, khcompany, quin, rate, amt, remark) => {
        setInput(prevInput => ({
            ...prevInput,
            sr: sr, date: date, kno: kno, name: name, khname: khname, khcompany: khcompany, quin: quin, rate: rate, amt: amt, remark: remark
        }))
        setNewedit("edit");
        setSredit(sr);
    }

    async function deletesanklan() {
        handleDeleteclose();
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/deletekhsale.php', { sr: srdelete, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                notify(response.data); // keep excellentdairy response
                setInput(prevInput => ({
                    ...prevInput,
                    kno: "",
                    name: "",
                    khname: "",
                    quin: "",
                    rate: "",
                    amt: "",
                }))
                setSredit("");
                setNewedit("new");
                setSrdelete("");
                getkhsale(dates.date1, dates.date2);
                if (inputRefs.current[1]) inputRefs.current[1].focus();
            }
        }).catch(err => {
            console.log(err);
        });
    }

    async function getkhname() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post(localStorage.getItem("khdate") === "yes" ? 'https://excellentdairy.com/dairy/php/cust/getkhname2.php' : 'https://excellentdairy.com/dairy/php/cust/getkhname.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) setKhnames(response.data);
        }).catch(err => {
            console.log(err);
        });
    }

    function handleEnterKeybutton(event, currentIndex) {
        if (event.key === 'Enter') {
            event.preventDefault();
            savekhadyasale();
            let nextIndex = null;
            if (currentIndex === 0) {
                if (input.name !== "") nextIndex = currentIndex + 1;
                else nextIndex = currentIndex;
            } else {
                nextIndex = currentIndex + 1;
            }
            if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
        }
        else if (event.key === "Backspace") {
            if (event.target.tagName === "BUTTON") {
                if (inputRefs.current[4]) inputRefs.current[4].focus();
            }
        }
    }

    useEffect(() => {
        if (inputRefs.current[1]) inputRefs.current[1].focus();

        const currentDate = new Date();
        const dayOfMonth = currentDate.getDate();
        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();

        let firstDayOfMonth;
        let lastDayOfMonth;

        if (localStorage.getItem("dur") === '10') {
            if (dayOfMonth >= 1 && dayOfMonth <= 10) {
                firstDayOfMonth = 1;
                lastDayOfMonth = 10;
            } else if (dayOfMonth >= 11 && dayOfMonth <= 20) {
                firstDayOfMonth = 11;
                lastDayOfMonth = 20;
            } else if (dayOfMonth >= 21 && dayOfMonth <= 31) {
                firstDayOfMonth = 21;
                lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
            }
        }
        else if (localStorage.getItem("dur") === '15') {
            if (dayOfMonth >= 1 && dayOfMonth <= 15) {
                firstDayOfMonth = 1;
                lastDayOfMonth = 10;
            } else if (dayOfMonth >= 16 && dayOfMonth <= 31) {
                firstDayOfMonth = 16;
                lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
            }
        }

        if (firstDayOfMonth !== undefined && lastDayOfMonth !== undefined) {
            const formattedDate1 = new Date(currentYear, currentMonth, firstDayOfMonth).toLocaleDateString('en-CA');
            const formattedDate2 = new Date(currentYear, currentMonth, lastDayOfMonth).toLocaleDateString('en-CA');

            setDates(prevInput => ({
                ...prevInput,
                date1: formattedDate1,
                date2: formattedDate2
            }));
            getkhsale(formattedDate1, formattedDate2);
        }
    }, [])

    async function getkhsale2(date1, date2) {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getkhsaledate.php', { date1: date1, date2: date2, date: input.date, time: input.time, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data.length > 0) {
                setDataSource(response.data);
                setInput(value => ({ ...value, tquin: response.data[0].tquin, tamt: response.data[0].tamt }));
                setTimeout(() => props.setProgress(100), 200);
                handleprintclose();
            }
            else {
                setDataSource([]);
                setInput(value => ({ ...value, tquin: "0", tamt: "0" }));
                handleprintclose();
            }
        }).catch(err => {
            console.log(err);
            handleprintclose();
        });
    }

    async function getkhsale(date1, date2) {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getkhsaledate.php', { date1: date1, date2: date2, date: input.date, time: input.time, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data.length > 0) {
                setDataSource(response.data);
                setInput(value => ({ ...value, tquin: response.data[0].tquin, tamt: response.data[0].tamt }));
                setTimeout(() => props.setProgress(100), 200);
            }
            else {
                setDataSource([]);
                setInput(value => ({ ...value, tquin: "0", tamt: "0" }));
            }
        }).catch(err => {
            console.log(err);
        });

        getkhname();
    }

    const setNewPeriod = async () => {
        getkhsale2(dates.date1, dates.date2)
    }

    const handleChange = async (event) => {
        const name = event.target.name;
        let valuecurrent = "";
        valuecurrent = event.target.value;
        setInput(value => ({ ...value, [name]: valuecurrent }));

        if (name === 'date') {
            if (value === "" || value === "dd/mm/yyyy" || value > today) {
                setInput(prevInput => ({
                    ...prevInput,
                    date: prevInput.date && prevInput.date <= today ? prevInput.date : today
                }));
                return;
            }
        }
    }

    const handleChangedates = async (event) => {
        const name = event.target.name;
        let valuecurrent = "";
        valuecurrent = event.target.value;
        setDates(value => ({ ...value, [name]: valuecurrent }));
    }

    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            var str = s.toString();
            for (var i = 0; i < str.length; i++) {
                var a = str.charCodeAt(i);
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    useEffect(() => {
        const currentDate1 = new Date(input.date);
        const dayOfMonth1 = currentDate1.getDate();
        const currentMonth1 = currentDate1.getMonth();
        const currentYear1 = currentDate1.getFullYear();

        let lastDayOfMonth1, firstday;

        if (localStorage.getItem("dur") === '10') {
            if (dayOfMonth1 >= 1 && dayOfMonth1 <= 10) {
                firstday = "1";
                lastDayOfMonth1 = 10;
            } else if (dayOfMonth1 >= 11 && dayOfMonth1 <= 20) {
                firstday = "11";
                lastDayOfMonth1 = 20;
            } else if (dayOfMonth1 >= 21 && dayOfMonth1 <= 30) {
                firstday = "21";
                lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate();
            }
        }
        else if (localStorage.getItem("dur") === '15') {
            if (dayOfMonth1 >= 1 && dayOfMonth1 <= 15) {
                firstday = "1";
                lastDayOfMonth1 = 15;
            } else if (dayOfMonth1 >= 16 && dayOfMonth1 <= 30) {
                firstday = "16";
                lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate();
            }
        }

        if (lastDayOfMonth1 !== undefined) {
            const formattedDate1 = new Date(currentYear1, currentMonth1, firstday).toLocaleDateString('en-CA');
            const formattedDate2 = new Date(currentYear1, currentMonth1, lastDayOfMonth1).toLocaleDateString('en-CA');
            setDates(prevInput => ({
                ...prevInput,
                date1: formattedDate1,
                date2: formattedDate2
            }));
        }
    }, [input.date]);

    const openkhadyajma = () => {
        setsubmenu("khadyajma");
        setHeadname(t("khsale.head.feed_due_credit"));
    };

    useEffect(() => {
        const currentDate1 = new Date(dates.date1);
        const dayOfMonth1 = currentDate1.getDate();
        const currentMonth1 = currentDate1.getMonth();
        const currentYear1 = currentDate1.getFullYear();

        let lastDayOfMonth1;

        if (localStorage.getItem("dur") === '10') {
            if (dayOfMonth1 >= 1 && dayOfMonth1 <= 10) {
                lastDayOfMonth1 = 10;
            } else if (dayOfMonth1 >= 11 && dayOfMonth1 <= 20) {
                lastDayOfMonth1 = 20;
            } else if (dayOfMonth1 >= 21 && dayOfMonth1 <= 30) {
                lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate();
            }
        }
        else if (localStorage.getItem("dur") === '15') {
            if (dayOfMonth1 >= 1 && dayOfMonth1 <= 15) {
                lastDayOfMonth1 = 15;
            } else if (dayOfMonth1 >= 16 && dayOfMonth1 <= 30) {
                lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate();
            }
        }

        if (lastDayOfMonth1 !== undefined) {
            const formattedDate2 = new Date(currentYear1, currentMonth1, lastDayOfMonth1).toLocaleDateString('en-CA');
            setDates(prevInput => ({
                ...prevInput,
                date2: formattedDate2
            }));
        }
    }, [dates.date1]);

    // ------------------ print
    const cellStyle = {
        border: '1px solid black',
        padding: '4px'
    };

    const printKhsale = () => {
        const content = document.getElementById('print-receipt-khsale');

        const kendraTitle = localStorage.getItem('kendra') || '';
        const kno = input.kno || '';
        const name = input.name || '';
        const dt = input.date || '';

        let khNamePrint = input.khname || '';
        let purDatePrint = '-';
        if (localStorage.getItem("khdate") === "yes" && khNamePrint.includes(":")) {
            const parts = khNamePrint.split(":").map(p => p.trim());
            khNamePrint = parts[0] || khNamePrint;
            purDatePrint = parts[1] || '-';
        }

        if (!content) {
            alert("Print section not found!");
            return;
        }

        const printWindow = window.open('', '', 'width=300,height=500');
        printWindow.document.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            @page { size: 58mm auto; margin: 0; }
            body { margin: 0; font-family: sans-serif; font-size: 12px; }
            .center-title { text-align: center; font-size: 11px; font-weight: bold; margin: 6px 0 2px; }
            .subinfo { font-size: 9px; font-weight: bold; margin-left: 1px; margin-bottom: 6px; line-height: 1.4; }
            .subinfo-row { display: flex; justify-content: space-between; margin-right: 6px; }
            table { border-collapse: collapse; width: 100%; margin-top: 10px; }
            th, td { border: 2px solid black; padding: 4px; text-align: center; }
            .thanks { text-align: center; font-weight: bold; font-size: 10px; margin-top: 12px; }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          <div class="center-title">${kendraTitle}</div>
          <div class="subinfo">
            <div class="subinfo-row"><span>${t("khsale.print.acc_no")}: ${kno}</span></div>
            <div class="subinfo-row"><span>${t("khsale.print.date")}: ${dt}</span></div>
            <div>${t("khsale.print.name")}: ${name}</div>
            <div>${t("khsale.print.feed")}: ${khNamePrint}</div>
            ${purDatePrint !== '-' ? `<div>${t("khsale.print.purchase_date")}: ${purDatePrint}</div>` : ``}
            ${input.remark ? `<div>${t("khsale.print.remark")}: ${input.remark}</div>` : ``}
          </div>

          ${content.innerHTML}

          <div class="thanks">---------</div>
          <div class="thanks">${t("khsale.print.thanks")}</div>
        </body>
      </html>
    `);
        printWindow.document.close();
    };

    return (
        <>
            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden="{true}"
                ref={refprint2}
                data-bs-target="#printinput2"
            />

            <div className="modal fade" id="printinput2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refprint2close} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <h5 className="modal-title" id="exampleModalLabel">{t("khsale.modal.period_title")}</h5>

                            <div className="rowbill">
                                <div className="mb-2">
                                    <span className='subheadsank'>{t("common.date")}</span>
                                    <input onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="date" className="form-control" autoComplete='off' id="date1" name="date1" value={dates.date1} onChange={handleChangedates} />
                                </div>

                                <span className='subheadbill'>{t("common.to")}</span>

                                <div className="mb-2">
                                    <span className='subheadsank'>{t("common.date")}</span>
                                    <input disabled onKeyDown={e => handleEnterKey(e, 1)} ref={ref => (inputRefs.current[1] = ref)} type="date" className="form-control" autoComplete='off' id="date2" name="date2" value={dates.date2} onChange={handleChangedates} />
                                </div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleprintclose}>{t("common.close")}</button>
                            <button type="button" className="btn btn-danger" onClick={setNewPeriod} >{t("common.ok")}</button>
                        </div>
                    </div>
                </div>
            </div>

            <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                hidden="{true}"
                ref={refdelete}
                data-bs-target="#deletekhsale"
            />

            <div className="modal fade" id="deletekhsale" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refdeleteclose} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <h5 className="modal-title" id="exampleModalLabel">{t("khsale.modal.delete_title")}</h5>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleDeleteclose}>{t("common.close")}</button>
                            <button type="button" className="btn btn-danger" onClick={deletesanklan} >{t("common.yes")}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="khadyamain">
                <div className="firstrowkhadya">
                    <img onClick={props.visibility} className='back' src={back} alt="" />
                    <div className="colmainkhadya">
                        <div className="firstrow2">
                            <div className="row1kh100">
                                <div className="mb-2">
                                    <span className='subheadsank'>{t("common.date")}</span>
                                    <input onKeyDown={e => handleEnterKey(e, 0)} ref={ref => (inputRefs.current[0] = ref)} type="date" className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"} autoComplete='off' id="date" name="date" value={input.date} onChange={handleChange} />
                                </div>

                                <div className="rightkhsaletop">
                                    <div>
                                        <div onClick={openkhadyajma} className="rightratib">
                                            <img className='backratib' src={cash} alt="" />
                                            <span className='subheadsankratib'>{t("khsale.head.feed_due_credit")}</span>
                                        </div>
                                    </div>
                                    <div className='divider'><span> | </span></div>

                                    <div onClick={handlePrint}>
                                        <img className='khadyaicon' src={date} alt="" />
                                        <span className='khsaleblack'>
                                            {t("khsale.text.period")} :
                                            <span className='khsaleblue'>
                                                {formatDate(dates.date1) + " " + t("common.to") + " " + formatDate(dates.date2)}
                                            </span>
                                        </span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='linekh' />

                <div className="row1khsale">
                    <div className="mb-2">
                        <span className='subheadsank'>{t("khsale.labels.account_no")}</span>
                        <input onKeyDown={e => handleEnterKey(e, 1)} ref={ref => (inputRefs.current[1] = ref)} type="number" className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"} autoComplete='off' id="kno" name="kno" value={input.kno} onChange={handleChange} />
                    </div>

                    <div className="mb-2">
                        <span className='subheadsank'>{t("khsale.labels.member_name")}</span>
                        <input type="text" disabled className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"} autoComplete='off' id="name" name="name" value={input.name} onChange={handleChange} />
                    </div>

                    <div className='classvauditentry'>
                        <label>
                            <div className="classbox">
                                {["उधारी", "रोख"].map((etype) => (
                                    <label key={etype}>
                                        <div className='classbox'>
                                            <input
                                                type="radio"
                                                name="etype"
                                                value={etype}
                                                checked={input.etype === etype}
                                                onChange={(e) => setInput(value => ({ ...value, etype: e.target.value }))}
                                            />
                                            <span className='classspan'>
                                                {etype === "उधारी" ? t("khsale.etype.credit") : t("khsale.etype.cash")}
                                            </span>
                                            <div className='vlineclass'></div>
                                        </div>
                                    </label>
                                ))}
                            </div>
                        </label>
                    </div>
                </div>

                <div className="row1khsale">
                    <div className="mb-2">
                        <span className='subheadsank'>
                            {t("khsale.labels.feed_name")}
                            {stock && (<span className='lblredkh'> {t("khsale.text.balance_stock", { stock })}</span>)}
                        </span>

                        <select
                            id="khname"
                            name="khname"
                            onKeyDown={e => handleEnterKey(e, 2)} ref={ref => (inputRefs.current[2] = ref)}
                            className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
                            value={input.khname}
                            onChange={handleChange}
                            onBlur={getstock}
                        >
                            {input.khname && !khnames.some(o => (localStorage.getItem("khdate") === "yes" ? `${o.khname} : ${o.purdate}` : o.khname) === input.khname) && (
                                <option value={input.khname}>{input.khname}</option>
                            )}

                            <option key={0} value={t("khsale.placeholders.select_feed")}>
                                {t("khsale.placeholders.select_feed")}
                            </option>

                            {khnames.map((opt, i) => {
                                const v = localStorage.getItem("khdate") === "yes"
                                    ? `${opt.khname} : ${opt.purdate}`
                                    : opt.khname;
                                return <option key={i + 1} value={v}>{v}</option>;
                            })}
                        </select>
                    </div>

                    <div className="mb-2">
                        <span className='subheadsank'>
                            {t("khsale.labels.feed_company")}
                            {stockcompany && (<span className='lblredkh'> {t("khsale.text.balance_stock", { stock: stockcompany })}</span>)}
                        </span>

                        <select
                            onKeyDown={e => handleEnterKey(e, 3)}
                            ref={ref => (inputRefs.current[3] = ref)}
                            className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
                            autoComplete='off'
                            id="khcompany"
                            name="khcompany"
                            value={input.khcompany}
                            onChange={handleChange}
                            onBlur={getstockcompany}
                        >
                            <option key={0} value={t("khsale.placeholders.select_company")}>
                                {t("khsale.placeholders.select_company")}
                            </option>

                            {company && [...new Set(company.map(opt => opt.khcompany))].map((uniqueCompany, index) => (
                                <option key={index} value={uniqueCompany}>{uniqueCompany}</option>
                            ))}
                        </select>
                    </div>

                    <div className="mb-2 kkh">
                        <span className='subheadsank'>{t("khsale.labels.qty")}</span>
                        <input onKeyDown={e => handleEnterKey(e, 4)} ref={ref => (inputRefs.current[4] = ref)} type="number" className={newedit === "new" ? "form-control" : "form-control editmode"} autoComplete='off' id="quin" name="quin" value={input.quin} onChange={handleChange} />
                    </div>

                    <div className="mb-2 kkh">
                        <span className='subheadsank'>{t("khsale.labels.rate")}</span>
                        <input onKeyDown={e => handleEnterKey(e, 5)} ref={ref => (inputRefs.current[5] = ref)} type="number" className={newedit === "new" ? "form-control" : "form-control editmode"} autoComplete='off' id="rate" name="rate" value={input.rate} onChange={handleChange} />
                    </div>

                    <div className="mb-2 kkh2">
                        <span className='subheadsank'>{t("khsale.labels.total")}</span>
                        <input disabled type="number" className={newedit === "new" ? "form-control" : "form-control editmode"} autoComplete='off' id="amt" name="amt" value={input.amt} onChange={handleChange} />
                    </div>

                    <div className="mb-2">
                        <span className='subheadsank'>{t("khsale.labels.remark")}</span>
                        <input type="text" onKeyDown={e => handleEnterKey(e, 6)} ref={ref => (inputRefs.current[6] = ref)} className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"} autoComplete='off' id="remark" name="remark" value={input.remark} onChange={handleChange} />
                    </div>
                </div>

                <div className="mb-2">
                    <div className="row1kh">
                        <div className="row1khsale">
                            {wait ? (
                                <button type="submit" className="btn btn-primary mx-1 sanksmall">
                                    {t("common.loading")}
                                </button>
                            ) : (
                                <button onClick={savekhadyasale} onKeyDown={e => handleEnterKeybutton(e, 0)} ref={ref => (inputRefs.current[7] = ref)} type="submit" className="btn btn-primary mx-1 sanksmall">
                                    {newedit === "new" ? t("common.save") : t("common.update")}
                                </button>
                            )}

                          
                        </div>

                        <div className="rightkhsale">
                            <img className='khadyaicon' src={khadya} alt="" />
                            <span className='khsaleblack'>
                                {t("khsale.summary.total_qty")} :
                                <span className='khsalered'>{parseFloat(input.tquin).toFixed(2)}</span>
                            </span>
                            <span className='khsaleblack2'>|</span>
                            <span className='khsaleblack2'>
                                {t("khsale.summary.amount")} :
                                <span className='khsalered'>₹{parseFloat(input.tamt).toFixed(2)}</span>
                            </span>
                        </div>
                    </div>
                </div>

                <div className="firstrow2">
                    <div className="table-containerkhsale">
                        <table id="myTable" className="table table-bordered">
                            <thead>
                                <tr>
                                    <th className='thsmall' scope="col">{t("khsale.table.sr")}</th>
                                    <th className='thsmall' scope="col">{t("khsale.table.date")}</th>
                                    <th className='thsmall' scope="col">{t("khsale.table.time")}</th>
                                    <th className='thsmall' scope="col">{t("khsale.table.acc_no")}</th>
                                    <th className='thlarge' scope="col">{t("khsale.table.name")}</th>
                                    <th className='thsmall' scope="col">{t("khsale.table.feed")}</th>
                                    <th className='thsmall' scope="col">{t("khsale.table.company")}</th>
                                    <th className='thsmall' scope="col">{t("khsale.table.qty")}</th>
                                    <th className='thsmall' scope="col">{t("khsale.table.rate")}</th>
                                    <th className='thsmall' scope="col">{t("khsale.table.total")}</th>
                                    <th className='thsmall' scope="col">{t("khsale.table.action")}</th>
                                </tr>
                            </thead>

                            <tbody>
                                {value.length > 0
                                    ? tableFilter.map((user, index) =>
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{user.date}</td>
                                            <td>{user.timee}</td>
                                            <td>{user.kno}</td>
                                            <td>{user.name}</td>
                                            <td>{user.khname}</td>
                                            <td>{user.khcompany}</td>
                                            <td>{user.quin}</td>
                                            <td>{user.rate}</td>
                                            <td>{user.amt}</td>
                                            <td>
                                                <UilEditAlt onClick={() => { handleedit(user.sr, user.date, user.kno, user.name, user.khname, user.khcompany, user.quin, user.rate, user.amt, user.remark) }} className="icsank" />
                                                <UilTrash onClick={() => { handleDelete(user.sr) }} className="icsank" />
                                            </td>
                                        </tr>
                                    )
                                    : DataSource.map((user, index) =>
                                        <tr key={index}>
                                            <td className='thsmallkh'>{index + 1}</td>
                                            <td className='thsmallkh2'>{formatDate(user.date)}</td>
                                            <td className='thsmallkh'>{user.timee}</td>
                                            <td className='thsmallkh'>{user.kno}</td>
                                            <td className='thsmallkh3'>{user.name}</td>
                                            <td className='thsmallkh3'>{user.khname}</td>
                                            <td className='thsmallkh'>{user.khcompany}</td>
                                            <td className='thsmallkh'>{user.quin}</td>
                                            <td className='thsmallkh'>{user.rate}</td>
                                            <td className='thsmallkh'>{user.amt}</td>
                                            <td>
                                                <UilEditAlt onClick={() => { handleedit(user.sr, user.date, user.kno, user.name, user.khname, user.khcompany, user.quin, user.rate, user.amt, user.remark) }} className="icsank" />
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div id="print-receipt-khsale" style={{ display: 'none' }}>
                    <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '12px', textAlign: 'center' }}>
                        <thead>
                            <tr>
                                <th style={cellStyle}>{t("khsale.print_table.feed")}</th>
                                <th style={cellStyle}>{t("khsale.print_table.qty")}</th>
                                <th style={cellStyle}>{t("khsale.print_table.rate")}</th>
                                <th style={cellStyle}>{t("khsale.print_table.total")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={cellStyle}>{(() => {
                                    if (!input.khname) return "";
                                    if (localStorage.getItem("khdate") === "yes" && input.khname.includes(":")) {
                                        return input.khname.split(":")[0].trim();
                                    }
                                    return input.khname;
                                })()}</td>
                                <td style={cellStyle}>{input.quin}</td>
                                <td style={cellStyle}>{input.rate}</td>
                                <td style={cellStyle}>{input.amt}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <ToastContainer />
            </div>
        </>
    )
}

export default Khsale
